/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class LocationSelectorDirectiveController {
        public static $inject : string[] = ['DealerwareLocationCollection'];

        private _locations: any;
        private _selectedLocation: any;
        private _selectedLocationId: number;
        private _defaultLocationId: number;
        private _defaultLocation: any;

        public onLocationSelected: any;
        public onLocationsLoaded: any;
        public label: string;
        public hideLabel: boolean;
        public disableSingleLocationAutoSelect: boolean;
        public hideForSingleLocation: boolean;
        public locationActions: any;


        public get locations() : any {
            return this._locations;
        }

        public set locations(locations : any) {
            this._locations = locations;
        }

        public get defaultLocationId() : number {
            return this._defaultLocationId;
        }

        public set defaultLocationId(locationId : number) {
            this._defaultLocationId = locationId;
            this.selectedLocationId = this._defaultLocationId;
        }

        public get defaultLocation() : any {
            return this._defaultLocation;
        }

        public set defaultLocation(location : any) {
            this._defaultLocation = location;
            if (this._defaultLocation) {
                this.selectedLocation = this._defaultLocation;
            }
        }

        public get selectedLocationId() : number {
            return this._selectedLocationId;
        }

        public set selectedLocationId(locationId : number) {
            this._selectedLocationId = locationId;
            if (this._selectedLocationId) {
                var _location = this.lookupLocationForSelectedId(this._selectedLocationId);
                this._selectedLocation = _location;
            }
            this.locationSelected();
        }

        public get selectedLocation() : any {
            if (!this._selectedLocation && this.selectedLocationId) {
                this._selectedLocation = this.lookupLocationForSelectedId(this.selectedLocationId);
            }
            return this._selectedLocation;
        }

        public set selectedLocation(location : any) {
            this._selectedLocation = location;
            if (location) {
                this._selectedLocationId = (this._selectedLocation.hasOwnProperty('data')) ? this._selectedLocation.data.id : this._selectedLocation.id;
            } else {
                this._selectedLocationId = undefined;
            }

            this.locationSelected();
        }


        constructor(public DealerwareLocationCollection: any) {

            this.loadLocations();
        }


        public loadLocations() : void {
            var _self = this;

            this.DealerwareLocationCollection.activeLocations({ promise: true }).then(
                function(returnValue : any) {
                    _self.locations = returnValue;
                    if (! _self.disableSingleLocationAutoSelect && _self.locations.data.length == 1 ) {
                        _self.selectedLocation = _self.locations.data[0];
                    } else if (_self.defaultLocationId && !_self.selectedLocation) {
                        _self.selectedLocationId = _self.defaultLocationId;
                    }
                    if (_self.onLocationsLoaded && angular.isFunction(_self.onLocationsLoaded)) {
                        _self.onLocationsLoaded({locations: _self.locations});
                    }
                },
                function(response : any) {
                    console.log("LocationSelectorDirectiveController load locations error:",response);
                }
            );
        }

        public lookupLocationForSelectedId(locationId: number) : any {
            var _return : any = undefined;

            if (locationId && this.locations && this.locations.hasOwnProperty('data') && this.locations.data && angular.isArray(this.locations.data)) {
                this.locations.data.forEach(function(val: any, idx: number) {
                    if (val.data.id == locationId) {
                        _return = val;
                        return false;
                    }
                });
            }
            return _return;
        }

        public locationSelected() : void {
            if (this.selectedLocationId && this.selectedLocation && this.onLocationSelected && angular.isFunction(this.onLocationSelected)) {
                var location = this.selectedLocation;
                this.onLocationSelected({location: location,locationId: this.selectedLocationId});
            }
        }
    }

    getDealerwareWebComponentsModule().controller('LocationSelectorDirectiveController', LocationSelectorDirectiveController);

    export class LocationSelectDirective implements ng.IDirective {

        public static $inject : string[] = [ ];

        public restrict         : string    =   'E';
        public controller       : any       =   'LocationSelectorDirectiveController';
        public controllerAs     : string    =   'locationSelectController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            defaultLocationId               : '=',
            defaultLocation                 : '=',
            onLocationSelected              : '&',
            onLocationsLoaded               : '&?',
            label                           : '@',
            hideLabel                       : '=',
            selectedLocation                : '=?',
            disableSingleLocationAutoSelect : '=?',
            hideForSingleLocation           : '=?'
        };
        public transclude       : boolean   =   false;
        public require          : string[]  =   [];

        // Allows customization of location item template.  Implemented as template instead of
        // templateUrl so that an element based (E) directive can be used to represent the location
        // item.  That functionality doesn't yet work since I believe we might have to add a
        // manual compile step below before it can..
        //
        public template         : any       =   ( $element: ng.IAugmentedJQuery, $attrs: any ) => {

            if ($attrs.directive !== undefined) {
                return '<' + $attrs.directive + '</' + $attrs.directive + '>';
            }

            return '<div ng-include="\''
                + ( $attrs.template !== undefined
                    && $attrs.template || '/components/location/location_selector_directive.html'
                  )
                + '\'"></div>';
        };

        constructor() { }

        public link : ng.IDirectiveLinkFn = (
            scope   :   any,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ngModel   :   any
        ) => { }
    }

    getDealerwareWebComponentsModule().directive("dealerwareLocationSelect",
        ( ) => new LocationSelectDirective()
    );
}
